import script from "./FeatureSpecPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureSpecPanel.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureSpecPanel.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__